import { ChangeDetectionStrategy, Component, computed } from '@angular/core';
import { ErrorComponent } from 'error-ui';
import { ProductComponentBase } from '../../../ProductComponentBase';
import { ProductResultListComponent } from '../../../layouts/product-result/product-result-list';

@Component({
  selector: 'ideal-product-complimentary',
  imports: [ProductResultListComponent, ErrorComponent],
  standalone: true,
  templateUrl: './product-complimentary.component.html',
  styleUrls: ['./product-complimentary.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: {
    '[class.loading]': 'loading()',
    '[class.no-content]': '!hasContent()',
  },
})
export class ProductComplimentaryComponent extends ProductComponentBase {
  protected readonly complementary = this.productStore.productComplementary;
  protected readonly complementaryIds = computed(() =>
    this.complementary()
      .filter((product): product is NonNullable<typeof product> => product != null)
      .map((product) => product.id),
  );

  protected override computeIsLoading = () => this.complementary.loading;
  protected override computeHasContent = () => computed(() => !!this.complementary.error() || this.complementary().length > 0);
}
